import $ from 'jquery';
import { EXPAND } from './define';

const $ctx = $('#brcColl');
const $linkTag = $ctx.find ( '.link_tag' );
const TAG_PARAM_NAME = 'brunch_tag';
const TAG_MAX_HEIGHT = $ctx.find ( '.tab_tag' ).height () * 2;
const tagParam = SF.getParam( TAG_PARAM_NAME );
let page = EXPAND.START_OF_PAGE;

function ExpandAPIUrl( p ) {
  let params = {
    m: "BRC",
    query: decodeURIComponent ( window.utf8Query ),
    p,
    type: 'list'
  };
  if ( tagParam ) {
    params[ TAG_PARAM_NAME ] = tagParam;
  }
  return SF.getQsUrl ( params, 2 );
}

const pager = new SF.pager({
  navigation : $('#brcColl .coll_tit > .paging_nav'),
  list : $('#brcColl .coll_recomm .cont_info'),
  viewCount : 1,
  isInfinite : false
});

function setTab(self) {
  console.log('test');
  self.parent().find('li').removeClass('on');
  self.addClass('on');
}

$ctx.find('.expender').on('click', function (e) {

  $(this).hasClass('close') ? smartLog(this, EXPAND.LOG_FOLD, e) : smartLog(this, EXPAND.LOG_EXPAND, e);
});

const extendModule = new SF.extend ( {
  container: $ctx.find ( '.list_brunch' ),
  expender: $ctx.find ( '.extend_comp' ),
  viewCount: 3,
  source: function ( response ) {
    $.ajax ( {
      url: ExpandAPIUrl ( page ),
      dataType: 'html',
      success: function ( data, textStatus ) {
        page += 1;
        onComplete ( data, textStatus, response );
      },
      error: function ( jqXHR, textStatus ) {
        onError ( jqXHR, textStatus, response );
      }
    } );
  }
});


function isEnd( $html ) {
  return $html.find (`.${EXPAND.FLAG_IS_END}`).length > 0 || page === EXPAND.END_OF_PAGE;
}

function onComplete( html, textStatus, response ) {
  if ( textStatus === 'success' ) {
    const $htmlWrapper = $ ( '<div></div>' ).append ( html );
    response ( $htmlWrapper.find ( 'li' ), isEnd ( $htmlWrapper ) );
  } else {
    onError ( null, textStatus, response );
  }
}

function onError( jqXHR, textStatus, response ) {
  page -= 1;
  response ( null );
  throw new Error ( textStatus );
}

function tagMore() {
  let tagTab = $ctx.find ( '.item_tag' ).height ();
  if ( tagTab < TAG_MAX_HEIGHT ) {
    $linkTag.hide ();
  }
}

function tagTabMoreEvt() {
  $linkTag.on ( 'click', function (e) {
    let $this = $ ( this );
    const $tag = $ctx.find ( '.tab_tag' );
    const arrowIco = '<span class="ico_brc"></span>';


    if ( $tag.hasClass ( 'fold_tag' ) ) {
      $tag.removeClass ( 'fold_tag' );
      $this.html ( '더보기' + arrowIco );
      smartLog(this, EXPAND.MORE_FOLD, e);
    } else {
      $tag.addClass ( 'fold_tag' );
      $this.html ( '접기' + arrowIco );
      smartLog(this, EXPAND.MORE_EXPAND, e);
    }
  } );
}

tagTabMoreEvt ();
tagMore ();


/** WEBPACK FOOTER **
 ** ./src/brunch/index.js
 **/